// extracted by mini-css-extract-plugin
module.exports = {"main":"Logout_main__1hPFO","header":"Logout_header__1-aPH","text":"Logout_text__2ivjb"};